import script from "./message.vue?vue&type=script&setup=true&lang=js"
export * from "./message.vue?vue&type=script&setup=true&lang=js"

import "./message.vue?vue&type=style&index=0&id=74059f19&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74059f19"]])

export default __exports__